module.exports = __webpack_public_path__ + "media/apps/check-circle_2x-6137281d.png";